<template>
  <div id="system-manage-email-actions">
    <site-search-group class="mar-b-16"
                       v-model="params.keyword"
                       placeholder="Enter letter subject | Event name"
                       @search="getList()"
                       @clear="handleClear" />
    <div class="action-table">
      <ipub-table :columns="columns"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:templateList="{text}">
          <div>
            <div v-for="item in text"
                 :key="item.templateId">
              {{item.subject}}
            </div>
          </div>
        </template>
        <template v-slot:actions="{record}">
          <ipub-tooltip placement="bottomRight">
            <div slot="title">Associated Mail Template</div>
            <ipub-icon type="iconReference"
                       @click="associated(record)" />

          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <div></div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
